/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
      },
      {
        Header: "applicationConfiguration.tableColumns.name",
        accessor: "name",
      },
      {
        Header: "applicationConfiguration.tableColumns.date",
        accessor: "date",
      },
]

export const HolidayNamecolumns: TableColumn[] = [
  {
      Header: "tableCommon.sl_no",
      accessor: "slno",
    },
    {
      Header: "applicationConfiguration.tableColumns.name",
      accessor: "name",
    },
]

export const weakDayColumns: TableColumn[] = [
  {
      Header: "tableCommon.sl_no",
      accessor: "slno",
    },
    {
      Header: "applicationConfiguration.tableColumns.weakdaysName",
      accessor: "weekDaysName",
    },
    {
      Header: "applicationConfiguration.tableColumns.fromDate",
      accessor: "fromDate",
    },
    {
      Header: "applicationConfiguration.tableColumns.toDate",
      accessor: "toDate",
    },
]

interface TableColumn {
    Header: string;
    accessor: string;
  }